export default "__VITE_ASSET__750f781a__"